import React from "react";
import { QuoraAPI as ExampleShapeClass } from "../shapes/QuoraAPI";
import { linkedComponent } from "../package";

export const ExampleComponent = linkedComponent<ExampleShapeClass>(
    ExampleShapeClass,
    ({ source }) => {
        //note that typescript knows that 'source' is an instance of the Shape you linked this component to
        return <div></div>;
    }
);
